import { KeyInfoType } from '@dap/sanity/types';
import { Card, Divider, Stack, Typography, styled } from '@mui/material';
import { messages } from '@dap/common/i18n';
import { useTranslation } from 'react-i18next';
import KeyInfoEmail from './KeyInfoEmail';
import KeyInfoLink from './KeyInfoLink';
import KeyInfoText from './KeyInfoText';
import { ContactCard, ContactCardProps } from '@dap/common/ui';

import { KeyInfoTextField, KeyInfoEmailField, KeyInfoLinkField } from '@dap/sanity/types';

type Items =
  | KeyInfoTextField
  | KeyInfoEmailField
  | KeyInfoLinkField
  | (ContactCardProps & { _type: KeyInfoType.person });

export interface KeyInfoCardProps {
  items: Items[];
}

function KeyInfoCard({ items }: KeyInfoCardProps) {
  const { t } = useTranslation(['common', 'services']);

  if (!items?.length) return null;

  return (
    <Card
      sx={{
        paddingRight: 4,
      }}
    >
      <Typography variant="h4" component="h2">
        {t(messages.services.keyInfo, { ns: 'services' })}
      </Typography>

      <CustomDivider sx={{ marginTop: 1, marginBottom: 2 }} />

      <Stack spacing={2}>
        {items?.map((item, index) => {
          switch (item._type) {
            case KeyInfoType.email:
              return <KeyInfoEmail key={index} value={item} />;
            case KeyInfoType.link:
              return <KeyInfoLink key={index} value={item} />;
            case KeyInfoType.text:
              return <KeyInfoText key={index} value={item} />;
            case KeyInfoType.person:
              return <ContactCard key={index} {...item} />;
          }
        })}
      </Stack>
    </Card>
  );
}

const CustomDivider = styled(Divider)`
  width: 176px;
`;

export default KeyInfoCard;
